export const toBase64 = (text: string) => btoa(text);
